// ── Session ───────────────────────────────────────────────────
const SK = "fin_s5";

export const saveSess = (d) => {
  try {
    localStorage.setItem(SK, JSON.stringify(d));
  } catch {}
};

export const loadSess = () => {
  try {
    const s = localStorage.getItem(SK);
    return s ? JSON.parse(s) : null;
  } catch {
    return null;
  }
};

export const clearSess = () => {
  try {
    localStorage.removeItem(SK);
  } catch {}
};
